import { render, staticRenderFns } from "./reviewWidgetStats.vue?vue&type=template&id=47e17c5a&"
import script from "./reviewWidgetStats.vue?vue&type=script&lang=js&"
export * from "./reviewWidgetStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e17c5a')) {
      api.createRecord('47e17c5a', component.options)
    } else {
      api.reload('47e17c5a', component.options)
    }
    module.hot.accept("./reviewWidgetStats.vue?vue&type=template&id=47e17c5a&", function () {
      api.rerender('47e17c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidgetStats.vue"
export default component.exports